import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "How much does digital marketing cost?",
    a: "Real estate marketing budgets typically start from ₹50,000/month for ad spend plus a management fee, but every project is different. We tailor the plan to your project size, micro-market, and lead volume goals after a free consultation.",
    testid: "faq-cost",
  },
  {
    q: "Do you work with builders and developers?",
    a: "Yes — that's our specialty. We work with real estate developers, builders, and channel partners across Pune, helping them generate site-visit-ready leads consistently month after month.",
    testid: "faq-builders",
  },
  {
    q: "Do you manage Google and Meta Ads?",
    a: "Absolutely. We run end-to-end Google Ads (Search, Display, YouTube, PMax) and Meta Ads (Facebook & Instagram) campaigns — including audience research, creative production, landing pages, tracking setup, and ongoing optimisation.",
    testid: "faq-google-meta",
  },
  {
    q: "Can you create landing pages?",
    a: "Yes. Our team builds fast-loading, mobile-first landing pages purpose-built for real estate lead capture — with strong CTAs, inquiry forms, project galleries, and integrated tracking pixels.",
    testid: "faq-landing-pages",
  },
  {
    q: "How quickly can campaigns start?",
    a: "Most campaigns go live within 5–7 business days from onboarding — including strategy, creative production, landing page build, and tracking setup. Existing accounts can sometimes launch even sooner.",
    testid: "faq-timeline",
  },
];

export const FAQ = () => {
  return (
    <section data-testid="faq-section" className="section-pad bg-white">
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        <div className="mb-12">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-orange mb-3">FAQs</div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-navy leading-tight tracking-tight">
            Questions, answered.
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={f.testid}
              value={`item-${i}`}
              data-testid={f.testid}
              className="border-b border-slate-200"
            >
              <AccordionTrigger
                data-testid={`${f.testid}-trigger`}
                className="text-left text-base sm:text-lg font-semibold text-navy hover:text-orange hover:no-underline py-5"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent
                data-testid={`${f.testid}-content`}
                className="text-slate-600 text-sm sm:text-base leading-relaxed pb-5"
              >
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
